import React, { useState } from 'react'
import Tabs, { TabsType } from '../../components/partials/tabs'
import Files from './file'
import DetailFile from './bond-file-detail'

// Tabs Array
const tabs: TabsType = [
  {
    label: 'File',
    index: 1,
    Component: Files,
  },
  {
    label: 'Detail File',
    index: 2,
    Component: DetailFile,
  },
]

const BondDataManagement = () => {
  const [selectedTab, setSelectedTab] = useState<number>(tabs[0].index)
  const [data, setData] = useState<any>({})

  return (
    <div>
      <Tabs
        needResponsive={true}
        selectedTab={selectedTab}
        pageName="Bond Data Management"
        onClick={setSelectedTab}
        setSelectTab={setSelectedTab}
        tabs={tabs}
        dataInput={data}
        setData={setData}
      />
    </div>
  )
}

export default BondDataManagement
